export default __webpack_public_path__ + "static/media/contact-form-photo.d78f1970.png";